import styled from "styled-components";

export const StyledListSubheader = styled.li`
    ${({ theme }) => theme.fonts.mulishBold};
    font-size: 11px;
    color: ${({ theme }) => theme.colors.dimGrey};
    list-style: none;
    display: flex;
    align-items: center;
    :after {
        content: '';
        width: 100%;
        height: 1px;
        margin-left: 10px;
        background-color: ${({ theme }) => theme.colors.mediumGrey};
    }
    ${({ customStyle }) => customStyle && customStyle};
`;